import * as React from 'react';
import './AccountInfo.scss';
import './ModelInfo.scss';
import UserModel from 'src/model/user.model';
import LocaleFormating from 'src/translation/localeFormating';
import AccountInfoHeader from '../AccountInfoHeader';
import AccountInfoFooter from '../AccountInfoFooter';
import Loader from 'src/components/common/Loader';
import Checkbox from 'src/components/common/Checkbox';
import AddressModel from 'src/model/address.model';
import env from 'src/shared/env';
import tokenService from 'src/services/token/TokenService';
import { signInActions } from 'src/store/modules/signin';
import { default as userActions } from 'src/store/modules/user/actions'
import { goToBillingAddress, billingAddressUrl,goToHome,goToAccount } from 'src/utils/navigation';
import contactVerificationServiceInstance from 'src/services/contactVerification/contactVerification';
import UserUpdateInfo from 'src/components/UserUpdateInfo';
import Modal from 'src/components/common/Modal';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { Prompt } from 'react-router-dom';
import Mobile from 'src/components/AR-Summary/Mobile';
interface IAccountInfoProps {
  userData: UserModel;
  t?: any;
  signout(): void;
  getUserDetails: () => void;
}

function formatAddress(address: AddressModel): string {
  return `${address.addressLine1}, ${address.addressLine2} ${address.addressLine3} ${address.addressLine4}, ${address.stateCode} ${address.postalCode}`;
}
function Alert(props: any) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export function AccountInfo(props: IAccountInfoProps) {
  const [timeLeft, setTimeLeft] = React.useState(0);
  const timerRef = React.useRef(null);
  const [phoneOtpVerifyDirect, setPhoneOtpVerifyDirect] = React.useState('');
  const [buttonEnabled, setButtonEnabled] = React.useState(false);
  localStorage.setItem('accountpage', 'yes');
  // localStorage.removeItem('rpage');
  const activeAccount = localStorage.getItem("activeAccount");
  const validationEligible = localStorage.getItem('-userValidationEligible'); 
  const emailVerify = localStorage.getItem('-emailVerify');
  const accountNumber = props.userData ? props.userData.accountId : '';
  const userId = props.userData ? props.userData.clientIdentity : '';
  const [phoneOtp, setPhoneOtp] = React.useState('');
  const [emailOtp, setEmailOtp] = React.useState('');
  const [skpVerifyEmail, setSkpVerifyEmail] = React.useState(0);
  const [phoneOtpGenerated, setPhoneOtpGenerated] = React.useState(false);
  const [emailOtpGenerated, setEmailOtpGenerated] = React.useState(false);
  const [emailValidateOtp, setEmailValidateOtp] = React.useState(false);
  const [mobileValidateOtp, setMobileValidateOtp] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [phoneError, setPhoneError] = React.useState('');
  const [emailError, setEmailError] = React.useState('');
  const [emailVerifyError, setEmailVerifyError] = React.useState('');
  const [showEdit, setShowEdit] = React.useState(false);
  const [clientInfoToEdit, setClientInfoToEdit] = React.useState('email');
  const [openToast, setOpenToast] = React.useState(true);
  const [displayPhone, setDisplayPhone] = React.useState('');
  const [isModalOpen, setIsModalOpen] = React.useState(true); 
  const [isErrorModalOpen, setIsErrorModalOpen] = React.useState(false);  
  const [isHighlighted, setIsHighlighted] = React.useState(false);
  const [isMobileHighlighted, setIsMobileHighlighted] = React.useState(false);
  const [remainingSkips, setRemainingSkips] = React.useState(3);
  const emailSkipCounts = localStorage.getItem('-emailSkipCounts');
  const skipsUsed = emailSkipCounts ? parseInt(emailSkipCounts, 10) : 0;
  const maxSkipPending = 3 - skipsUsed;
  const emailRef = React.useRef(null);
  const mobileRef = React.useRef(null);
  const emailOtpRef = React.useRef(null);
  const mobileOtpRef = React.useRef(null);
  const [firstCount, setfirstCount] = React.useState('');
  const [preferencesCallCount, setpreferencesCallCount] = React.useState('');
  const [preferenceError, setPreferenceError] = React.useState('');
  const [preferenceNotificationError, setPreferenceNotificationError] = React.useState('');
  const [preferenceSave, setPreferenceSave] = React.useState('');
  const preferenceSaveSucessRef = React.useRef(null);
  const deliveryPrefranceRef = React.useRef(null); 
  const deliveryNotificationPrefranceRef = React.useRef(null); 
  const [isEmailEditing, setIsEmailEditing] = React.useState(false);
  const [isMobileEditing, setIsMobileEditing] = React.useState(false);
  const [isFocus, setIsFocus] = React.useState(false);
  const [error, setError] = React.useState({
    email: '',
    phone: '',
    sentEmailOtp: '',
    sentEmailOtpError: '',
    sentMobileOtp: '',
    sentMobileOtpError: '',
    emailVeryOTPError:'',
    emailVerySuccess:'',
    mobileVerySuccess:'',
    mobileVeryOTPError:'',
    alreadyVerifyEmailError:'',
    alreadyVerifyMobileError:''
  });

   

  const [preferencesSms, setPreferencesSms] = React.useState({    
    user_id:accountNumber,
    notificationType: '',
    languagePreference: env.REACT_APP_BASE_ENVIRONMENT === 'US' ? 'EN' :'',
    orderPreferences: [],
  });

  const [isDirty, setIsDirty] = React.useState(false); // Track if changes are made

  const handleUnload = (event:any) => {
    if (isDirty) {
      event.preventDefault();
      event.returnValue = ''; // Necessary for displaying the default browser confirm dialog
    }
  };

  const prevProps = React.useRef(props);

  const {
    mobileNumber: phone,
    email,
    emailSkipCount,
    mobileValid: isPhoneVerified,
    emailValid: isEmailVerified
  } = props.userData;
  
  const [userEmail, setUserEmail] = React.useState('');
  const [userMobile, setUserMobile] = React.useState('');  
  const [emailOTP, setEmailOTP] = React.useState(''); 

  /* 
  React.useEffect(() => {
    if (userEmail) {
      const timeout = setTimeout(() => {
        setUserEmail('');
        setEmailOtpGenerated(false);
        setPhoneOtpGenerated(false);
        setEmailValidateOtp(false);
        setMobileValidateOtp(false);
      }, 60000); // 1 minute
  
      return () => clearTimeout(timeout); 
    }
  
    return undefined;; 
  }, [userEmail]);

  React.useEffect(() => {
    if (userMobile) {
      const timeout = setTimeout(() => {
        setUserMobile('');
        setEmailOtpGenerated(false);
        setPhoneOtpGenerated(false);
        setEmailValidateOtp(false);
        setMobileValidateOtp(false);
      }, 60000); // 1 minute
  
      return () => clearTimeout(timeout); 
    }
  
    return undefined;; 
  }, [userMobile]);
  */

  // email and phone verify timeout function
  const verifyTimeout = (verifyType:string) => {
    if(verifyType ==='email') {
      const timeout = setTimeout(() => {
        setUserEmail('');
        setEmailOtpGenerated(false);
        setPhoneOtpGenerated(false);
        setEmailValidateOtp(false);
        setMobileValidateOtp(false);
      }, 900000); // 15 minute
      return () => clearTimeout(timeout); 

    } else {
      const timeout = setTimeout(() => {
        setUserMobile('');
        setEmailOtpGenerated(false);
        setPhoneOtpGenerated(false);
        setEmailValidateOtp(false);
        setMobileValidateOtp(false);
      }, 900000); // 15 minute
      return () => clearTimeout(timeout); 
    }
    
  }
  

  // handle edit email
  const handleUpdateEmailClick = () => {    
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail); 
    if (!isValid) {
      setError((prev) => ({
        ...prev,
        email: t('accountInfo.invalidEmail')
      }));
      emailRef.current?.focus();
      setIsEmailEditing(true);
    } else {

      if(userEmail === email && (props.userData.emailValid || emailValidateOtp)) {
        setError((prev) => ({
          ...prev,
          alreadyVerifyEmailError: t('common.emailAlreadyVerified')
        }));
        emailRef.current?.focus();
        setIsEmailEditing(true);
      } else {
        setError((prev) => ({
        ...prev,
        email: '',
        phone: '',
        sentEmailOtp: '',
        sentEmailOtpError: '',
        sentMobileOtp: '',
        sentMobileOtpError: '',
        emailVeryOTPError:'',
        emailVerySuccess:'',
        mobileVerySuccess:'',
        mobileVeryOTPError:'',
        alreadyVerifyEmailError:'',
        alreadyVerifyMobileError:''
      }));
      setUserMobile('');
      handleEmailOtp('generate');
      setIsEmailEditing(false);
      }   
      
    }    
  }  

  const handleEmailEditClick = () => {
    if(!phoneOtpGenerated) {      
     setUserMobile('');
    }
    setUserEmail(userEmail?userEmail:email);
    setError((prev) => ({
      ...prev,
      alreadyVerifyMobileError:''
    }));
    setIsEmailEditing(true);
    setIsMobileEditing(false);
  };
  const handleEmailCancelClick = () => {

    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userEmail); 
    if (!isValid || !emailOtpGenerated) {
      setUserEmail('');
    }

    setError((prev) => ({
      ...prev,
      email: '',
      alreadyVerifyEmailError:'',
      alreadyVerifyMobileError:''
    }));
        
      /*  
      setUserEmail('');         
      setError((prev) => ({
        ...prev,
        email: '',
        phone: '',
        sentEmailOtp: '',
        sentEmailOtpError: '',
        sentMobileOtp: '',
        sentMobileOtpError: '',
        emailVeryOTPError:'',
        mobileVeryOTPError:''
      })); */
      setIsEmailEditing(false);
  };
 
  const handleChangeEmail = (e:any) => {       
    setUserEmail(e.target.value);
    
  };

  const handleChangeVerifyEmailOTP = (e:any) => { 
    const value = e.target.value.trim();
    const isValid = /^\d{0,6}$/.test(value);
    // Only allow up to 6 digits
    if (isValid) {
      setEmailOTP(value);
    }
    
 }

  const handleVerifyEmailOTP = () => {      
    const isValid = /^\d{6}$/.test(emailOTP);
    if (!isValid) {
      setError((prev) => ({
        ...prev,
        emailVeryOTPError: t('accountInfo.validOTP'),
        email: '',
        phone: '',
        sentEmailOtp: '',
        sentEmailOtpError: '',
        sentMobileOtp: '',
        sentMobileOtpError: '',
        emailVerySuccess:'',
        mobileVerySuccess:'',
        mobileVeryOTPError:'',
        alreadyVerifyEmailError:'',
        alreadyVerifyMobileError:''
      }));
      emailOtpRef.current?.focus();
    } else {      
      setError((prev) => ({
        ...prev,
        email: '',
        phone: '', 
        sentEmailOtp: '',
        sentEmailOtpError: '',
        sentMobileOtp: '',
        sentMobileOtpError: '',
        emailVeryOTPError:'',
        emailVerySuccess:'',
        mobileVerySuccess:'',
        mobileVeryOTPError:'',
        alreadyVerifyEmailError:'',
        alreadyVerifyMobileError:''
      }));
      handleEmailOtpVerification(emailOTP);
    }
 }

 // Cancel OTP validation
 const cancelEmailOtpValidation = () => {  
       setEmailOtpGenerated(false);
       setUserEmail('');
       setError((prev) => ({
        ...prev,
        email: '',
        phone: '',
        sentEmailOtp: '',
        sentEmailOtpError: '',
        sentMobileOtp: '',
        sentMobileOtpError: '',
        emailVeryOTPError:'',
        emailVerySuccess:'',
        mobileVerySuccess:'',
        mobileVeryOTPError:'',
        alreadyVerifyEmailError:'',
        alreadyVerifyMobileError:''
        
      }));
 }
  

  // handle click for mobile
  const handleUpdateMobileEditClick = () => {        
    const isValid = /^\(\d{3}\) \d{3}-\d{4}$/.test(userMobile?userMobile:formatPhoneNumber(phone));

    if (!isValid) {
      setError((prev) => ({
        ...prev,
        phone: t('accountInfo.invalidMobile'),
        email: '',
        sentEmailOtp: '',
        sentEmailOtpError: '',
        sentMobileOtp: '',
        sentMobileOtpError: '',
        emailVeryOTPError:'',
        mobileVeryOTPError:'',
        emailVerySuccess:'',
        mobileVerySuccess:'',
        alreadyVerifyEmailError:'',
        alreadyVerifyMobileError:''
      }));
      mobileRef.current?.focus();
      setIsMobileEditing(true);
    } else {

      if(userMobile.replace(/\D/g, '') === phone && (props.userData.mobileValid || mobileValidateOtp)) {
        setError((prev) => ({
          ...prev,
          alreadyVerifyMobileError: t('common.mobileAlreadyVerified')
        }));
        mobileRef.current?.focus();
        setIsMobileEditing(true);
      } else {

        setError((prev) => ({
          ...prev,
          email: '',
          phone: '',
          sentEmailOtp: '',
          sentEmailOtpError: '',
          sentMobileOtp: '',
          sentMobileOtpError: '',
          emailVeryOTPError:'',
          emailVerySuccess:'',
          mobileVerySuccess:'',
          mobileVeryOTPError:'',
          alreadyVerifyEmailError:'',
          alreadyVerifyMobileError:''
        }));
        setUserEmail('');
        handlePhoneOtp();
        setIsMobileEditing(false);

      }
        


      
      
    }
  }
  const handleMobileEditClick = () => {
    if(!emailOtpGenerated) {      
      setUserEmail('');
    }
    setUserMobile(formatPhoneNumber(userMobile?userMobile:phone));
    setError((prev) => ({
      ...prev,
      alreadyVerifyEmailError:''
    }));
    setIsMobileEditing(true);
    setIsEmailEditing(false);
  };
  const handleMobileCancelClick = () => {
    const isValid = /^\(\d{3}\) \d{3}-\d{4}$/.test(userMobile?userMobile:formatPhoneNumber(phone));

    if (!isValid || !phoneOtpGenerated) {
      setUserMobile('');
    }
    setError((prev) => ({
      ...prev,
      phone: '',
      alreadyVerifyMobileError:''
    }));
    /*  
    setUserMobile('');  
    setError((prev) => ({
      ...prev,
      email: '',
      phone: '',
      sentEmailOtp: '',
      sentEmailOtpError: '',
      sentMobileOtp: '',
      sentMobileOtpError: '',
      emailVeryOTPError:'',
      mobileVeryOTPError:''
    })); */
    setIsMobileEditing(false);
  };
 
  const handleChangeMobile = (e:any) => {
    setUserMobile(formatPhoneNumber(e.target.value));
  };

  const handleChangeVerifyMobileOTP = (e:any) => { 
    const value = e.target.value.trim();
    const isValid = /^\d{0,6}$/.test(value);
    // Only allow up to 6 digits
    if (isValid) {
      setPhoneOtp(value);
    }
    
 }

  const handleVerifyMobileOTP = () => {
    const isValid = /^\d{6}$/.test(phoneOtp);
    if (!isValid) {
      setError((prev) => ({
        ...prev,
        mobileVeryOTPError: t('accountInfo.validOTP'),
        email: '',
        phone: '',
        sentEmailOtp: '',
        sentEmailOtpError: '',
        sentMobileOtp: '',
        sentMobileOtpError: '',
        emailVerySuccess:'',
        mobileVerySuccess:'',
        emailVeryOTPError:'',
        alreadyVerifyEmailError:'',
        alreadyVerifyMobileError:''
      }));
      mobileOtpRef.current?.focus();
    } else {      
      setError((prev) => ({
        ...prev,
        email: '',
        phone: '',
        sentEmailOtp: '',
        sentEmailOtpError: '',
        sentMobileOtp: '',
        sentMobileOtpError: '',
        emailVeryOTPError:'',
        mobileVeryOTPError:'',
        emailVerySuccess:'',
        mobileVerySuccess:'',
        alreadyVerifyEmailError:'',
        alreadyVerifyMobileError:''
      }));
      handleMobileOtpVerification(phoneOtp);
    }
 }

 // Cancel OTP validation
 const cancelMobileOtpValidation = () => {  
  setPhoneOtpGenerated(false);
  setUserMobile('');
  setError((prev) => ({
   ...prev,
   email:'',
   sentEmailOtpError:'',
   emailVeryOTPError: t('accountInfo.validOTP'),
   sentEmailOtp:'',
   phone: '',
   sentMobileOtp: '',
   sentMobileOtpError: '',
   mobileVeryOTPError:'',
   emailVerySuccess:'',
   mobileVerySuccess:'',
   alreadyVerifyEmailError:'',
   alreadyVerifyMobileError:''
   
 }));
}

  

  const rawBalance =
    props.userData && props.userData.accountCredit
      ? props.userData.accountCredit.balance
      : null;
  const rawLimit =
    props.userData && props.userData.accountCredit
      ? props.userData.accountCredit.creditLimit
      : null;

  const balance = rawBalance
    ? LocaleFormating.formatCurrency(parseFloat(rawBalance))
    : '';
  const limit = rawLimit
    ? LocaleFormating.formatCurrency(parseFloat(rawLimit))
    : '';

  const billingAddress =
    props.userData && props.userData.billingAddress
      ? formatAddress(props.userData.billingAddress)
      : '';
  const { t } = props;  


  React.useEffect(() => {
    window.addEventListener('beforeunload', handleUnload);

    return () => {
      window.removeEventListener('beforeunload', handleUnload);
    };
  }, [isDirty]);

  React.useEffect(() => {  
    if((!props.userData.emailValid || !props.userData.mobileValid) && !isFocus) {      
      handleFocus();
      setIsFocus(true);
    }
    if(preferencesSms.notificationType === '') {
      setPreferencesSms({
        ...preferencesSms,
        notificationType: 'EMAIL',
      });
    }
    if(preferencesSms.orderPreferences.length === 0) {     

      const value = 'ORDER_RECEIVED';
      const newOrderPreferences = preferencesSms.orderPreferences.includes(value)
      ? preferencesSms.orderPreferences.filter((pref) => pref !== value)
      : [...preferencesSms.orderPreferences, value];
      setPreferencesSms({ ...preferencesSms, orderPreferences: newOrderPreferences });
    }

    // Clear any existing timer before setting a new one
    if (timerRef.current) {
      clearTimeout(timerRef.current);
    }


    if (timeLeft > 0) {
      timerRef.current = setTimeout(() => {
        setTimeLeft(prev => prev - 1);
      }, 1000);

      // return () => clearTimeout(timer); // Cleanup the timer
    }


    if (phone && phone.includes('+1')) {
      const disp = phone.substring(2);
      setDisplayPhone(disp);
    }
    const otpUrl = localStorage.getItem('otpUrl') || '';
    setEmailOtp(atob(getParamFromURL(otpUrl)));
    if (
      emailOtp !== '' &&
      emailOtp !== undefined &&
      Number(emailOtp) !== 0 &&
      !props.userData.emailValid &&
      userId !== undefined && firstCount ===''
    ) {
      setfirstCount('verified');
      handleEmailOtpVerification(emailOtp);
      
    }
  }, [preferencesCallCount,props.userData,timeLeft]);

  const resetTimer =() => {
    
    setTimeout(() => {
      setTimeLeft(15);
    }, 1000);
  }

  const getParamFromURL = (url: string) => {
    let otpParam = '';
    if (url.includes('otp')) {
      const queryStringIndex = url.indexOf('?');
      const queryString = url.slice(queryStringIndex + 1);
      const paramsArray = queryString.split('&');
      const params: any = {};
      paramsArray.forEach(param => {
        const [key, value] = param.split('=');
        params[key] = value;
      });
      otpParam = params['otp'];
    }
    return otpParam;
  };
  

  const handlePhoneOtp = async () => {
    resetTimer();
    setLoading(true);
    setPhoneOtpGenerated(false);   
    setEmailOtpGenerated(false);   
    setPhoneOtp('');   
    const currentUrl = window.location.pathname.split('/');
    let languageFromUrl = currentUrl[2];
    if(languageFromUrl === 'fr') {
      languageFromUrl = 'FR';
    } else {
      languageFromUrl = 'EN';
    }
    const region = currentUrl[1];
    const generateOtpResponse = await contactVerificationServiceInstance.generatePhoneOtp(
      userId,
      userMobile?userMobile.replace(/\D/g, ''):phone.replace(/\D/g, ''),
      languageFromUrl,
      region
    );   
    if (generateOtpResponse.data === 'SUCCESS') {         
      verifyTimeout('mobile');
      setLoading(false);  
      setPhoneOtpGenerated(true);
        setError((prev) => ({
          ...prev,
          sentMobileOtp: t('accountInfo.mobileOtpSent'),
          sentMobileOtpError:''
        }));
      return;
    } else {
      if (generateOtpResponse.data === 'OTP_GENERATION_FAILED') {
        setLoading(false);
        setPhoneOtpGenerated(false);
        setError((prev) => ({
          ...prev,
          sentMobileOtp: "",
          sentMobileOtpError:t('accountInfo.mobileOtpSentFailed')
        }));
      } else if (generateOtpResponse.data === 'RETRY_TIMEOUT_NOT_REACHED') {
        setLoading(false);
        setPhoneOtpGenerated(false);
        setError((prev) => ({
          ...prev,
          sentMobileOtp: "",
          sentMobileOtpError:t('accountInfo.mobileOtpSentFailed')
        }));
      }
      return;
    }
  };

  const formatPhoneNumber = (value:any) => {
    if(!value) {
      return value;
    }
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) { 
      return phoneNumber; 
    }
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };
  

   const handleEmailOtp = async (actionType: string) => {
    resetTimer();
    setIsHighlighted(false);
    setLoading(true);    
    setEmailValidateOtp(false);
    setIsErrorModalOpen(true);
    setEmailError('');
    setEmailOtpGenerated(false);
    setPhoneOtpGenerated(false);
    setEmailOTP('');
    setError((prev) => ({
      ...prev,
      sentEmailOtp: "",
      sentEmailOtpError:''
    }));
    const skipParam = actionType === 'skip' ? true : false;
    const currentUrl = window.location.pathname.split('/');
    let languageFromUrl = currentUrl[2];
    if(languageFromUrl === 'fr') {
      languageFromUrl = 'FR';
    } else {
      languageFromUrl = 'EN';
    }
    const region = currentUrl[1];
    const generateOtpResponse = await contactVerificationServiceInstance.generateEmailOtp(
      userId,
      userEmail?userEmail:email,
      languageFromUrl,
      region
    );

    if (actionType === 'generate') {
      if (generateOtpResponse.data === 'SUCCESS') {  
        
        verifyTimeout('email');
        setEmailOtpGenerated(true);
        emailOtpRef.current?.focus();
        setError((prev) => ({
          ...prev,
          sentEmailOtp: t('accountInfo.emailOtpSent'),
          sentEmailOtpError:'',
          emailVeryOTPError:''
        }));        
       setLoading(false); 
      } else if (generateOtpResponse.data === 'OTP_GENERATION_FAILED') {
        setEmailOtpGenerated(false);
        setEmailError('');
        setError((prev) => ({
          ...prev,
          sentEmailOtp:'',
          sentEmailOtpError: t('accountInfo.emailOtpSentFailed'),
          emailVeryOTPError:''
        }));
        setLoading(false);
      } else if (generateOtpResponse.data === 'RETRY_TIMEOUT_NOT_REACHED') {
        setEmailOtpGenerated(false);
        setError((prev) => ({
          ...prev,
          sentEmailOtp:'',
          sentEmailOtpError: t('accountInfo.emailOtpSentFailed'),
          emailVeryOTPError:''
        }));
        setLoading(false);
      }
      return;
    }
  };

  const handleMobileOtpVerification = async (mobileOtp:any) => {
    setLoading(true);
    setError((prev) => ({
      ...prev,
      mobileVerySuccess:''
    }));
    const phoneOtpInt = Number(mobileOtp);
    const currentUrl = window.location.pathname.split('/');
    let languageFromUrl = currentUrl[2];
    if(languageFromUrl === 'fr') {
      languageFromUrl = 'FR';
    } else {
      languageFromUrl = 'EN';
    }
    const region = currentUrl[1]; 
    const phoneVerifiedStatus = await contactVerificationServiceInstance.validatePhoneOtp(
      userId,
      phoneOtpInt,
      userMobile?userMobile.replace(/\D/g, ''):phone.replace(/\D/g, ''),
      languageFromUrl,
      region
    );
    if (phoneVerifiedStatus.data) {  
      props.getUserDetails();      
      setMobileValidateOtp(true);
      setPhoneOtpGenerated(false); 
      setError((prev) => ({
        ...prev,
        mobileVerySuccess: `${t('accountInfo.mobileVerifiedSuccess')}${!props.userData.emailValid ? ' ' + t('accountInfo.needToVerifyEmail') : ''}`,
        sentMobileOtpError:''
      }));
      setLoading(false);
    } else {
       setMobileValidateOtp(false);
       mobileOtpRef.current?.focus();
      setError((prev) => ({
        ...prev,
        sentMobileOtp: "",
        sentMobileOtpError:t('accountInfo.mobileOtpInvalid')
      }));      
      setLoading(false);
    }
  };

  const handleEmailOtpVerification = async (emailOtpVal:any) => {        
    setLoading(true);
    setEmailValidateOtp(false);    
    setError((prev) => ({
      ...prev,
      sentEmailOtp: "",
      sentEmailOtpError:'',
      emailVerySuccess:''
    }));
    const currentUrl = window.location.pathname.split('/');
    let languageFromUrl = currentUrl[2];
    if(languageFromUrl === 'fr') {
      languageFromUrl = 'FR';
    } else {
      languageFromUrl = 'EN';
    }
    const region = currentUrl[1];
    const emailVerifiedStatus = await contactVerificationServiceInstance.validateEmailOtp(
      userId,
      emailOtpVal,
      userEmail?userEmail:email,
      languageFromUrl,
      region
    );    
    if (emailVerifiedStatus.data) {
      props.getUserDetails();
      setEmailValidateOtp(true);
      setEmailOtpGenerated(false);      
      setError((prev) => ({
        ...prev,
        emailVerySuccess: `${t('common.varifyEmailSuccess')}${!props.userData.mobileValid ? ' ' + t('accountInfo.needToVerifyMobile') : ''}`,
        sentEmailOtpError:''
      }));
      setLoading(false);
  } else {
    setEmailValidateOtp(false);
    emailOtpRef.current?.focus();
      setError((prev) => ({
        ...prev,
        sentEmailOtp: "",
        sentEmailOtpError:t('common.verifyUnsuccessmsg')
      }));      
    setLoading(false);
  };
}

  const handleEditClick = (contact: string, secondParam = 'default value') => {
    
    if(secondParam === ""){
      setPhoneOtpVerifyDirect('PhoneOtpVerifyDirect');
    } else {
      setPhoneOtpVerifyDirect('');
    }
    setIsHighlighted(false);
    setIsMobileHighlighted(false);
    setShowEdit(!showEdit);
    setClientInfoToEdit(contact);
    localStorage.removeItem('phoneVerificationLink');
    localStorage.removeItem('emailVerificationLink');
  };
  const handleModalClose = () => {
    localStorage.removeItem('phoneVerificationLink');
    localStorage.removeItem('emailVerificationLink');
    setShowEdit(!showEdit);
  };


  const handleVerfiyModalCloseCheck = () => {
    handleFocus();
  }

  const handleFocus = () => {
    setIsHighlighted(true);
    // Scroll the window to the center
    const elementRect = emailRef.current.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset;
    const middle = absoluteElementTop - (window.innerHeight / 2);
    
    window.scrollTo({
      top: middle,
      behavior: 'smooth'
    });
  };

  // Handle the input event to remove the highlight when typing starts
  const handleInput = () => {
    setIsHighlighted(false);
    setIsMobileHighlighted(false);
  };

  // Conditional style for the textbox
  const inputStyle: React.CSSProperties = {
    // border: isHighlighted ? '2px solid red' : '1px solid black',
    padding: '10px 10px 10px 0px',
    outline: 'none',
    wordWrap: 'break-word',
    // width: '70%'
  };

  const mobileStyle: React.CSSProperties = {
    /* border: isMobileHighlighted ? '2px solid red' : '1px solid black', */
    padding: '10px',
    outline: 'none',
    width: '70%' 
  };

  const handleMobileFocus = () => {
    setIsMobileHighlighted(true);
    // Scroll the window to the center
    const elementRect = mobileRef.current.getBoundingClientRect();
    const absoluteElementTop = elementRect.top + window.pageYOffset;
    const middle = absoluteElementTop - (window.innerHeight / 2);
    
    window.scrollTo({
      top: middle,
      behavior: 'smooth'
    });
  };


  const handlePrefrenceSaveSuccessFocus = () => {
    // Scroll the window to the center
    if(preferenceSaveSucessRef.current) {
      
      const elementRect = preferenceSaveSucessRef.current.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - (window.innerHeight / 2);
      
      window.scrollTo({
        top: middle,
        behavior: 'smooth'
      });

    }
  };

  const handlePrefrenceErroFocus = () => {
    // Scroll the window to the center
    if(deliveryPrefranceRef.current) {      
      const elementRect = deliveryPrefranceRef.current.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - (window.innerHeight / 2);      
      window.scrollTo({
        top: middle,
        behavior: 'smooth'
      });

    }
  };

  const handlePrefrenceNotificationErroFocus = () => {
    // Scroll the window to the center
    if(deliveryNotificationPrefranceRef.current) {      
      const elementRect = deliveryNotificationPrefranceRef.current.getBoundingClientRect();
      const absoluteElementTop = elementRect.top + window.pageYOffset;
      const middle = absoluteElementTop - (window.innerHeight / 2);      
      window.scrollTo({
        top: middle,
        behavior: 'smooth'
      });

    }
  };

  

  const handleSmsRadioChange = (event:any) => {
    setIsMobileHighlighted(false);
    setIsHighlighted(false);
    setPreferenceError('');
    if(event.target.value === "EMAIL" && !props.userData.emailValid) {        
      setPreferenceError(t('common.needToVerifyEmail'));  
      handleFocus();
    } else if(event.target.value === "SMS" && !props.userData.mobileValid) {        
      setPreferenceError(t('common.needToVerifyphone')); 
      handleMobileFocus(); 
    } else if(event.target.value === "BOTH" && !props.userData.mobileValid && !props.userData.emailValid) {        
      setPreferenceError(t('common.needToVerifyEmailPhone'));  
    } else if(event.target.value === "BOTH" && !props.userData.mobileValid && props.userData.emailValid) {        
      setPreferenceError(t('common.needToVerifyphone'));  
      handleMobileFocus(); 
    } else if(event.target.value === "BOTH" && props.userData.mobileValid && !props.userData.emailValid) {        
      setPreferenceError(t('common.needToVerifyEmail')); 
      handleFocus(); 
    } 
    setPreferencesSms({
      ...preferencesSms,
      notificationType: event.target.value,
    });
    /*
     if (event.target.value === "NONE") {
      setPreferencesSms({
        user_id: props.userData.accountId,
        notificationType: event.target.value,
        languagePreference: 'EN',
        orderPreferences: [],
      });   
    } else {
      setPreferencesSms({
        ...preferencesSms,
        notificationType: event.target.value,
      }); 
    } */
    
  };

  const handleLanguagePreferenceChange = (e:any) => {
    setPreferencesSms({ ...preferencesSms, languagePreference: e.target.value });
  };

  const handleNotificationSmsChange = (e:any) => {
    
    const value = e.target.value;
    const newOrderPreferences = preferencesSms.orderPreferences.includes(value)
      ? preferencesSms.orderPreferences.filter((pref) => pref !== value)
      : [...preferencesSms.orderPreferences, value];
      setPreferencesSms({ ...preferencesSms, orderPreferences: newOrderPreferences });
      /*
      if(preferencesSms.notificationType === 'NONE') {
        setPreferencesSms({
          user_id: props.userData.accountId,
          notificationType: 'NONE',
          languagePreference: 'EN',
          orderPreferences: [],
        });  
      
      } else {
        setPreferencesSms({ ...preferencesSms, orderPreferences: newOrderPreferences });

      } */

    
  };

  const handleSaveOrderPrefences = async () => {
    
    setLoading(true);
    const preferencesJson = JSON.stringify(preferencesSms);
    
    const orderPrefrencesStatus = await contactVerificationServiceInstance.saveOrderPrefernces(
      userId,
      accountNumber,
      preferencesSms
    ); 
    if (orderPrefrencesStatus.data) {
       setPreferenceSave('success');
       localStorage.removeItem("rpage");
       setTimeout(() => {
        setPreferenceSave('');
      }, 5000);        
    setLoading(false);
    } else {
      setPreferenceSave('failed');
      setTimeout(() => {
        setPreferenceSave('');
      }, 5000);       
    setLoading(false);  	      

    }
  };


  const savePreferences = () => {
    setPreferenceError('');
    setPreferenceNotificationError('');
    if(preferencesSms.notificationType === "EMAIL" && !props.userData.emailValid) {        
      setPreferenceError(t('common.needToVerifyEmail'));  
    } else if(preferencesSms.notificationType === "SMS" && !props.userData.mobileValid) {        
      setPreferenceError(t('common.needToVerifyphone'));  
    } else if(preferencesSms.notificationType === "BOTH" && !props.userData.mobileValid && !props.userData.emailValid) {        
      setPreferenceError(t('common.needToVerifyEmailPhone'));  
    } else if(preferencesSms.notificationType === "BOTH" && !props.userData.mobileValid && props.userData.emailValid) {        
      setPreferenceError(t('common.needToVerifyphone'));  
    } else if(preferencesSms.notificationType === "BOTH" && props.userData.mobileValid && !props.userData.emailValid) {        
      setPreferenceError(t('common.needToVerifyEmail'));  
    } else if(!preferencesSms.notificationType) {        
      setPreferenceError(t('common.deliveryPrefrencesSelect'));
      handlePrefrenceErroFocus();
    } else if(preferencesSms.orderPreferences.length === 0 && (preferencesSms.notificationType === "EMAIL" || preferencesSms.notificationType === "SMS" || preferencesSms.notificationType === "BOTH" ) ) {        
      setPreferenceNotificationError(t('common.deliveryPrefrencesNotification'));
      handlePrefrenceNotificationErroFocus();
    } else {
      const preferencesJson = JSON.stringify(preferencesSms);
      handleSaveOrderPrefences();      
      handlePrefrenceSaveSuccessFocus();
         
    } 
  };

  return (
    <div className="rp-accountinfo">
     {((localStorage.getItem('rpage') === 'registered' && preferencesSms.notificationType === 'EMAIL') || (localStorage.getItem('rpage') === 'registered' && preferencesSms.notificationType === 'BOTH')) && (
       <div className="needToUpdatePrefrencesNotify">
       {t('common.needToUpdatePrefrences')}
       </div>
     )}
      <AccountInfoHeader />

      {showEdit && (
        <Modal showClose={false} handleCloseModal={handleVerfiyModalCloseCheck}>
          <UserUpdateInfo edit={clientInfoToEdit} handleModal={handleModalClose} handleOpenModel={clientInfoToEdit} timerval = {timeLeft} resetTimer={resetTimer} popupfordirectVerify={phoneOtpVerifyDirect}/>
        </Modal>
      )}

      <div className="rp-accountinfo--content">
      
      {/* email success and failure msg */}
      {error.sentEmailOtpError && !emailOtpGenerated && <p className="unSuccessMessageForVerify">{error.sentEmailOtpError}</p>} 
      {error.sentEmailOtp && emailOtpGenerated && !emailValidateOtp && <p className="successMessageForVerify">{error.sentEmailOtp}</p>}

      {/* email OTP success and failure msg */}
      {error.sentEmailOtpError  && !emailValidateOtp && emailOtpGenerated && <p className="unSuccessMessageForVerify">{error.sentEmailOtpError}</p>} 
      {error.emailVerySuccess && emailValidateOtp && <p className="successMessageForVerify">{error.emailVerySuccess}</p>}

      {/* mobile success and failure msg */}
      {error.sentMobileOtpError && !phoneOtpGenerated && <p className="unSuccessMessageForVerify">{error.sentMobileOtpError}</p>} 
      {error.sentMobileOtp && phoneOtpGenerated && <p className="successMessageForVerify">{error.sentMobileOtp}</p>}


      {/* mobile OTP success and failure msg */}
      {error.sentMobileOtpError  && !mobileValidateOtp && phoneOtpGenerated && <p className="unSuccessMessageForVerify">{error.sentMobileOtpError}</p>} 
      {error.mobileVerySuccess && mobileValidateOtp && <p className="successMessageForVerify">{error.mobileVerySuccess}</p>}
  
        
        
        <h1>{t('accountInfo.personalInfo')}</h1>
        <div className="container-fluid">
          <div className="row sepration">
            <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">
                {t('accountInfoHeader.accountNumber')}:
              </div>
              <div className="rp-accountinfo--item-detail">{accountNumber}</div>
            </div>
            {/* <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">Balance:</div>
              <div className="rp-accountinfo--item-detail">{balance}</div>
            </div> */}
            <div className="col-6 col-md-5">
              <div className="rp-accountinfo--item-title">
              {t('common.email')}:
                <label className="label-with-asterisk">
                  <sup>*</sup> {((props.userData.emailValid === false && !emailValidateOtp) || emailOtpGenerated)  && props.userData && (<span className="verifyTag">{t('account.needVerification')}</span>)}
                </label>
                {(props.userData.emailValid || emailValidateOtp) && !emailOtpGenerated && (
                  <span className="verified-text">✓ {t('accountInfo.verify')}</span>
                )}
              </div>
              <div className="rp-accountinfo--item-detail" > 
              {isEmailEditing ? (
                <>
                <input className="form--text-input email-input-box" ref={emailRef} onChange={handleChangeEmail} type="text" name="email" tabIndex={1} value={userEmail}/>
                
                <span className='emailAction'><a
                  onClick={() => handleUpdateEmailClick()}
                  className="update-symbol"
                >
                  {t('common.save')}
                </a>
                <a
                  onClick={() => handleEmailCancelClick()}
                  className="cancel-symbol"
                >
                  {t('common.cancel')}
                </a>
                </span>
                </>
              ):(
                <>
                <span ref={emailRef} style={inputStyle} onInput={handleInput}>{(userEmail==='' || userEmail=== undefined)?email:userEmail}</span>
                
                {emailOtpGenerated?
                <a style={{ width: '20%'}}
                className="edit-symbol edit-disabled">{t('common.editActionTxt')}</a>:
                <a style={{ width: '20%'}}
                  onClick={() => handleEmailEditClick()}
                  className="edit-symbol"
                >{t('common.editActionTxt')}</a>
                }
                
                </>
              )} 
              {error.email && <p className='validError'>{error.email}</p>} 
              {error.alreadyVerifyEmailError && <p className='validError'>{error.alreadyVerifyEmailError}</p>}             
                
                {!props.userData.emailValid && props.userData.email && !isEmailEditing && !emailOtpGenerated && !emailValidateOtp && (
                  <div className="verification-links">
                    <div>
                      <a
                        className="resend-code-button-disable send-verify-email"
                        onClick={(e: any) => {
                          handleEmailOtp('generate');
                        }}
                      >                        
                        {t('accountInfo.sendVerifyEmail')}
                      </a>                      
                    </div>
                  </div>
                )}
                {loading && <Loader />}
              </div>
            </div>
            <div className="col-6 col-md-3">
              <></>
            </div>
          </div>
          {!isEmailEditing  && emailOtpGenerated && (props.userData.email || userEmail)  && (          
          <div className="row email_otp">
            <div className="col-6 col-md-3">&nbsp;</div>
            <div className="col-6 col-md-5">
              <div className="rp-accountinfo--item-title">{t('common.emailOtp')}:</div>  
              <div className="rp-accountinfo--item-detail">
                <input className="form--text-input-otp-otp-email"  ref={emailOtpRef} onChange={handleChangeVerifyEmailOTP} type="text" name="emailOTP" tabIndex={1} value={emailOTP}/>
                <span className="emailAction"><a className="verify-update-symbol" onClick={e => handleVerifyEmailOTP()}  >{t('common.verifyOtp')} </a>
                <a onClick={e => cancelEmailOtpValidation()} className="verify-cancel-symbol">{t('common.cancel')}</a></span>
                 {error.emailVeryOTPError && <p className="validError">{error.emailVeryOTPError}</p>}  
                  <div className="verification-links">
                    <div>

                      {timeLeft>1 ?<><a className="resend-code-button-disable send-verify-email notResend">{t('common.emailResendOtpIn')}<span className="timeleft">({timeLeft})</span></a></>:
                      <a className="resend-code-button-disable send-verify-email Resend" onClick={(e: any) => {  handleEmailOtp('generate');  }}>{t('common.emailResendOtp')}</a>}
                      
                      </div>
                    </div></div></div>
                    <div className="col-6 col-md-3">&nbsp;</div>
            </div>
            )}

          <div className="row sepration" >
            <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">
                {t('common.userId')}:
              </div>
              <div className="rp-accountinfo--item-detail">{userId}</div>
            </div>
            <div className="col-6 col-md-5">
              <div className="rp-accountinfo--item-title">
              {t('common.phone')}:<label className="label-with-asterisk">
                   {((props.userData.mobileValid === false && !mobileValidateOtp) || phoneOtpGenerated ) && props.userData && (<span className="verifyTag">{t('account.needPhoneVerification')}</span>)}
                </label>
                {(props.userData.mobileValid || mobileValidateOtp) && !phoneOtpGenerated && (
                  <span className="verified-text">✓ {t('accountInfo.verify')}</span>
                )}
              </div>
              <div className="rp-accountinfo--item-detail">
              <span className="countryCodeDis" >
                {env.REACT_APP_BASE_ENVIRONMENT === 'US' ?(<>
              <img src="https://reliableparts.net/wp-content/uploads/2019/02/USA.png" className="AccountLogo"  alt="Logo" /> 
                 <span className="countryCode">US+1</span>
                 </>
                ):(
                  <>
                  <img src="https://reliableparts.net/wp-content/uploads/2019/02/CANADA.png" className="AccountLogo"  alt="Logo" />
                  <span className="countryCode">CA+1</span>
                  </>
                )}</span>
                {isMobileEditing ? (
                  <>
                  <input className="form--text-input mobile-input-box" ref={mobileRef} onChange={handleChangeMobile} type="text" name="phone" tabIndex={1} value={userMobile}/>
                  
                  <span className='emailAction'><a
                    onClick={() => handleUpdateMobileEditClick()}
                    className="update-symbol"
                  >
                    {t('common.save')}
                  </a>
                  <a
                    onClick={() => handleMobileCancelClick()}
                    className="cancel-symbol"
                  >
                    {t('common.cancel')}
                  </a>
                  </span>
                  </>
                  ):(
                  <>
                  
                  <span className="PhoneInput" onInput={handleInput} style={mobileStyle} ref={emailRef} id="phoneNumber">{formatPhoneNumber((userMobile==='' || userMobile=== undefined)?props.userData.mobileNumber:userMobile?.replace("+1", '')) ?? '9999999999'}</span>
                  {phoneOtpGenerated?
                  <a style={{ width: '20%'}}
                  className="edit-symbol edit-disabled">
                  {t('common.editActionTxt')}
                </a>:
                  <a style={{ width: '20%'}}
                    onClick={() => handleMobileEditClick()}
                    className="edit-symbol"
                  >
                    {t('common.editActionTxt')}
                  </a>}
                  
                  
                  
                  </>
                )}

               {error.phone && <p className="validError">{error.phone}</p>} 
               {error.alreadyVerifyMobileError && <p className="validError">{error.alreadyVerifyMobileError}</p>} 

                {!isMobileEditing && !phoneOtpGenerated && props.userData.mobileNumber && !props.userData.mobileValid && !mobileValidateOtp && (
                  <div className="verification-links verifyusingOtp">
                    <div className="horizontal-tags">
                      <a
                        className="resend-code-button-disable Resend"
                         onClick={() => handleUpdateMobileEditClick()}
                      >
                        {t('accountInfo.sendMobileOtp')}                        
                      </a>
                    </div>
                  </div>
                )}
                {((props.userData.mobileValid === false && !mobileValidateOtp) || phoneOtpGenerated || isMobileEditing ) && (                  
                <div className="mobile-verification-links verifyusingOtp">
                  <div className="horizontal-tags blankPhone">
                  {t('accountInfo.updateYourPhone')}                     
                  </div>
                </div>
                )}
              </div>
            </div>
            <div className="col-6 col-md-3">
              <></>
            </div>
          </div>
          {!isMobileEditing  && phoneOtpGenerated && (props.userData.mobileNumber || userMobile)  && (
          <div className="row email_otp">
            <div className="col-6 col-md-3">&nbsp;</div>
            <div className="col-6 col-md-5">
              <div className="rp-accountinfo--item-title">{t('common.mobileOtp')}:</div>
              <div className="rp-accountinfo--item-detail">
                <input className="form--text-input-otp-otp-email" ref={mobileOtpRef} onChange={handleChangeVerifyMobileOTP} type="text" name="emailOTP" tabIndex={1} value={phoneOtp}/>
                <span className="emailAction"><a className="verify-update-symbol" onClick={e => handleVerifyMobileOTP()}>{t('common.verifyOtp')}</a>
                 <a className="verify-cancel-symbol" onClick={e => cancelMobileOtpValidation()}>{t('common.cancel')}</a></span>
                 {error.mobileVeryOTPError && <p className="validError">{error.mobileVeryOTPError}</p>}   
                  <div className="verification-links">
                    <div>
                      
                    {timeLeft>1 ?<><a className="resend-code-button-disable send-verify-email notResend">{t('common.phoneResendOtpIn')}<span className="timeleft">({timeLeft})</span></a></>:
                      <a className="resend-code-button-disable send-verify-email Resend" onClick={() => handleUpdateMobileEditClick()}>{t('common.phoneResendOtp')}</a>}</div>
                    </div></div></div>
                    <div className="col-6 col-md-3">&nbsp;</div>
            </div>
            )}

            
        </div>

        <div className="row">
            <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">
               <></>
              </div>
              <div className="rp-accountinfo--item-detail"><></></div>
            </div>
            {/* <div className="col-6 col-md-3">
              <div className="rp-accountinfo--item-title">Balance:</div>
              <div className="rp-accountinfo--item-detail">{balance}</div>
            </div> */}
            <div className="col-6 col-md-5">
            <div className="rp-accountinfo--item-title">
                {t('accountInfo.billingAddress')}:
              </div>
              <div className="rp-accountinfo--item-detail">
                <div>{billingAddress}</div>
                <div className="rp-accountinfo--request-change">
                  <div onClick={e => goToBillingAddress()}>
                    <a href={billingAddressUrl()}>
                      {t('accountInfo.requestChange')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-6 col-md-3">
              <></>
            </div>
          </div>
      </div>   

      <AccountInfoFooter />
    </div>
  );
}
